export default {
    data: `[
   {
      "id":"6188f674-89af-48bc-b6ea-2dd7dc124cfd",
      "name":"space",
      "universe":"nature_science",
      "translations":{
         
      },
      "position":2,
      "hidden":0
   },
   {
      "id":"77d6e7a4-870b-4bb8-a20e-ec61c65fc975",
      "name":"dinosaurs",
      "universe":"nature_science",
      "translations":{
         
      },
      "position":3,
      "hidden":0
   },
   {
      "id":"ac8f7fb1-707e-4273-8927-53720fe23f68",
      "name":"alloween",
      "universe":"generic",
      "translations":{
         
      },
      "position":3,
      "hidden":0
   },
   {
      "id":"a110a3b7-df09-4dcf-beff-9bca90c164e1",
      "name":"christmas",
      "universe":"generic",
      "translations":{
         
      },
      "position":4,
      "hidden":0
   },
   {
      "id":"4b0705af-2c8e-4934-92cf-8fccd52d1943",
      "name":"classic_cartoon_past",
      "universe":"fiction",
      "translations":{
         
      },
      "position":0,
      "hidden":0
   },
   {
      "id":"26faeda9-720b-41a5-9b7e-d66ae76edc06",
      "name":"classic_cartoon_present",
      "universe":"fiction",
      "translations":{
         
      },
      "position":1,
      "hidden":0
   },
   {
      "id":"d7238ddf-10a1-48ce-a80d-03346d55b345",
      "name":"classic_cartoon_future",
      "universe":"fiction",
      "translations":{
         
      },
      "position":2,
      "hidden":0
   },
   {
      "id":"8a424dab-b65e-4a91-8df6-b18768de4a0f",
      "name":"future",
      "universe":"fiction",
      "translations":{
         
      },
      "position":3,
      "hidden":0
   },
   {
      "id":"d6197dcf-287a-4089-b1be-c495c8b64550",
      "name":"manga",
      "universe":"fiction",
      "translations":{
         
      },
      "position":4,
      "hidden":0
   },
   {
      "id":"24f29734-9086-4e93-abfb-500c0933c74e",
      "name":"crazy",
      "universe":"fiction",
      "translations":{
         
      },
      "position":5,
      "hidden":0
   },
   {
      "id":"1db47813-7170-4abb-8b2f-cc8062f9acd7",
      "name":"norwegian_wood",
      "universe":"fiction",
      "translations":{
         
      },
      "position":6,
      "hidden":0
   },
   {
      "id":"036c154f-285f-40b7-a090-97e102caf1df",
      "name":"1001_nights",
      "universe":"fiction",
      "translations":{
         
      },
      "position":7,
      "hidden":0
   },
   {
      "id":"97840354-e97c-4b58-a132-259ffea8669e",
      "name":"little_red_riding_hood",
      "universe":"fiction",
      "translations":{
         
      },
      "position":8,
      "hidden":0
   },
   {
      "id":"e18b0957-b4c6-4b78-a46f-f7cb5451b5e7",
      "name":"three_billy_goats_gruff",
      "universe":"fiction",
      "translations":{
         
      },
      "position":9,
      "hidden":0
   },
   {
      "id":"2a4f02f2-d790-4d31-aca5-b8b3df8a0217",
      "name":"historical_figures_world",
      "universe":"world_history",
      "translations":{
         
      },
      "position":0,
      "hidden":0
   },
   {
      "id":"0e65e71e-2b87-4d09-83a2-ad432d273864",
      "name":"international_politics_world",
      "universe":"world_history",
      "translations":{
         
      },
      "position":1,
      "hidden":0
   },
   {
      "id":"1c0420ff-439c-4b8d-8c81-63152a505fd2",
      "name":"stone_age",
      "universe":"world_history",
      "translations":{
         
      },
      "position":2,
      "hidden":0
   },
   {
      "id":"da7f00f3-b6d5-4c43-83fd-7eeeab2cc3b4",
      "name":"bronze_age",
      "universe":"world_history",
      "translations":{
         
      },
      "position":3,
      "hidden":0
   },
   {
      "id":"fde059ee-ad55-4964-91e8-2f6e29f1c837",
      "name":"iron_age",
      "universe":"world_history",
      "translations":{
         
      },
      "position":4,
      "hidden":0
   },
   {
      "id":"6bf94cb4-23b0-4f0f-b6b8-fac892472b75",
      "name":"egypt",
      "universe":"world_history",
      "translations":{
         
      },
      "position":5,
      "hidden":0
   },
   {
      "id":"5241609c-dac7-41af-a631-dda63ecd2af6",
      "name":"ancient_greece",
      "universe":"world_history",
      "translations":{
         
      },
      "position":6,
      "hidden":0
   },
   {
      "id":"522cd220-1e82-4d53-be3b-92b0470319b3",
      "name":"roman_empire",
      "universe":"world_history",
      "translations":{
         
      },
      "position":7,
      "hidden":0
   },
   {
      "id":"a026be5a-2961-4ccf-a840-48509bdb4a4e",
      "name":"viking_age",
      "universe":"world_history",
      "translations":{
         
      },
      "position":8,
      "hidden":0
   },
   {
      "id":"45444c01-27cb-44bb-8496-562e434b8ed1",
      "name":"world_war_2",
      "universe":"world_history",
      "translations":{
         
      },
      "position":11,
      "hidden":0
   },
   {
      "id":"8dd88b2d-a691-4409-b8e9-c6ea72b7f0a8",
      "name":"post_war_period",
      "universe":"world_history",
      "translations":{
         
      },
      "position":12,
      "hidden":0
   },
   {
      "id":"f6b6f978-e6e2-4f95-bf68-59d74b6b6832",
      "name":"18_19_century",
      "universe":"world_history",
      "translations":{
         
      },
      "position":9,
      "hidden":0
   },
   {
      "id":"2b69df46-0575-417b-a1ba-d4c5b7ffb5ea",
      "name":"middle_age",
      "universe":"world_history",
      "translations":{
         
      },
      "position":10,
      "hidden":0
   },
   {
      "id":"cbcac1e4-e41e-49f3-b9f4-31b7dbc5e219",
      "name":"you_and_me",
      "universe":"generic",
      "translations":{
         
      },
      "position":1,
      "hidden":0
   },
   {
      "id":"26d23134-655b-449c-9207-77461367c725",
      "name":"farm",
      "universe":"generic",
      "translations":{
         
      },
      "position":0,
      "hidden":0
   },
   {
      "id":"2eaf4998-1e0c-4046-b53f-1d64f8540278",
      "name":"sustainable_development",
      "universe":"nature_science",
      "translations":{
         
      },
      "position":0,
      "hidden":0
   },
   {
      "id":"67874303-7f24-4f2f-bf78-ff09ce63ee6b",
      "name":"biotechnology",
      "universe":"nature_science",
      "translations":{
         
      },
      "position":1,
      "hidden":0
   },
   {
      "id":"c2988776-5cd8-4533-bc4c-fb4756db1718",
      "name":"insects",
      "universe":"nature_science",
      "translations":{
         
      },
      "position":4,
      "hidden":0
   },
   {
      "id":"10aca2a6-5d8a-479e-a2d0-fef074628b2f",
      "name":"animals_and_landscapes",
      "universe":"nature_science",
      "translations":{
         
      },
      "position":5,
      "hidden":0
   },
   {
      "id":"c4c58a50-5ec6-47bf-b0ca-46ea1afe25e3",
      "name":"body",
      "universe":"nature_science",
      "translations":{
         
      },
      "position":6,
      "hidden":0
   },
   {
      "id":"fa7f5a28-0e7b-477d-ae27-1f7cbabf5150",
      "name":"science",
      "universe":"nature_science",
      "translations":{
         
      },
      "position":7,
      "hidden":0
   },
   {
      "id":"3c35a379-18e3-4fa5-9de9-bf066329854b",
      "name":"candyland",
      "universe":"fiction",
      "translations":{
         
      },
      "position":10,
      "hidden":0
   },
   {
      "id":"3ff13d2d-2a9b-405f-9ba7-961f6be3004d",
      "name":"christmas_gospel",
      "universe":"generic",
      "translations":{
         
      },
      "position":5,
      "hidden":0
   },
   {
      "id":"57604f42-5d03-4a1d-8083-7b08b6df6f9e",
      "name":"superheroes",
      "universe":"fiction",
      "translations":{
         
      },
      "position":11,
      "hidden":0
   },
   {
      "id":"e2c3c647-c16e-48ab-bdfb-0e328c73311b",
      "name":"identity",
      "universe":"generic",
      "translations":{
         
      },
      "position":6,
      "hidden":0
   },
   {
      "id":"24cbfe94-3097-4ae7-9262-c5d1cb21b9b8",
      "name":"norge_i_dag",
      "universe":"generic",
      "translations":{
         
      },
      "position":7,
      "hidden":0
   },
   {
      "id":"16c14dd7-b7af-4406-8a12-c002703ef61c",
      "name":"sverige_i_dag",
      "universe":"generic",
      "translations":{
         
      },
      "position":8,
      "hidden":0
   },
   {
      "id":"3affdc33-2c61-432a-8241-7b5a381f751e",
      "name":"frames",
      "universe":"generic",
      "translations":{
         
      },
      "position":9,
      "hidden":0
   },
   {
      "id":"64ccf087-32a0-4592-afb6-63b7b44441c8",
      "name":"easter_religious",
      "universe":"generic",
      "translations":{
         
      },
      "position":2,
      "hidden":0
   },
   {
      "id":"b489a926-068b-4437-9fbe-5864fadaa9de",
      "name":"easter_secular",
      "universe":"generic",
      "translations":{
         
      },
      "position":10,
      "hidden":0
   }
]`
};


/** WEBPACK FOOTER **
 ** ./docs/themesList.js
 **/